import { KeyboardBackspace } from '@mui/icons-material'
import { Button, Grid, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type Props = {
  name: string
  roomName?: string
}

export default function TopSection(props: Props) {
  const theme = useTheme()
  const texts = useTranslation(['common', 'locationCalendar']).t
  const navigate = useNavigate()

  return (
    <Grid
      container
      flexDirection='column'
      sx={{
        [theme.breakpoints.up('md')]: {
          paddingTop: '2rem'
        },
        [theme.breakpoints.down('md')]: {
          paddingTop: '1.5rem'
        },
        [theme.breakpoints.down('sm')]: {
          paddingTop: '1.5rem'
        }
      }}
    >
      <Button 
        variant='text'
        onClick={() => { navigate(-1)}}
        sx={{ marginBottom: '1rem' }}
      >
        <Grid
          container
          alignItems='center'
          gap='.5rem'
        >
          <KeyboardBackspace sx={{ marginTop: '-.125rem'}} />
          {texts('common:back')}
        </Grid>
      </Button>
      <Typography variant='h2'>
        {texts('locationCalendar:title')}
      </Typography>
      {
        props.name 
        && <Typography 
            variant='subtitle1'
            marginTop='.5rem'
          >
            {`${props.name}${props.roomName ? ` • ${props.roomName}` : ''}`}
          </Typography>
      }
    </Grid>
  )
}